import { useQuery } from "react-query";
import api from "../services/api";
import { User } from "../types";

export const useTimeBlockingNotAssigned = (userId: User["uid"]) =>
  useQuery([`user-${userId}-time-blocking-not-assigned`, userId], () =>
    api.fetchTimeBlockingEventsNotAssigned(userId)
  );
